import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import DashboardDoctorHeader from "../../components/MainHeader/DashboardDoctorHeader";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Calendar2 from "react-calendar";
import withDragAndDropExport from "react-big-calendar/lib/addons/dragAndDrop";
import {
  absenceAppointmentApi,
  cancelAppointmentApi,
  cityListApi,
  dateAvailabilityApi,
  delayAppointmentApi,
  doctorFetchAppointmentsApi,
  eraseDelayAppointmentApi,
  getAbsenceReasonApi,
  getCancelReasonApi,
  getDelayReasonApi,
  getRescheduleReasonApi,
  rescheduleAppointmentApi,
  updateAppointmentsOrderApi,
  updatePatientFromDoctorByPatientIdApi,
  updatePriorityApi,
  updateSlotApi,
} from "../../services/apiService";
import LoadingPage from "../../components/LoadingPage";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import StaticDayView from "../../components/static-day-view";

import icon1 from "../../assets/images/availability-icon2.svg";
import cancelIcon from "../../assets/images/cancel-btn.svg";
import dotlIcon from "../../assets/images/dot-icon.svg";
import { isPreviousDateFromCurrent } from "../../utils/commonData";
import Skeleton from "react-loading-skeleton";
import { format } from "date-fns";
import { resolveDefaultExport } from "../../utils/resolveDefaultExport";
import { useUserContext } from "../../context/UserContext";
import { useBroadcastListener } from "../../services/broadcast/broadcastService";
import { APPOINTMENT_BROADCAST_KEYS } from "@/services/broadcast/broadcastKeys";
import { parseAppointmentDate } from "../../features/doctor-appointments/appointments.utils";

const localizer = momentLocalizer(moment);
const withDragAndDrop = resolveDefaultExport(withDragAndDropExport);
const DnDCalendar = withDragAndDrop(Calendar);

import { useCities } from "@/queries/useLocalisationQuery"

const NurseAppointments = () => {
  const { userData } = useUserContext();
  const navigate = useNavigate();
  const nurseUserId = userData?.users?.id;
  const [view, setView] = useState("day");
  const [date, setDate] = useState(new Date());

  // const [mainEvents, setMainEvents] = useState([
  //   {
  //     title: "Rick Novak1",
  //     start: new Date(2024, 8, 24, 2, 0),
  //     end: new Date(2024, 8, 24, 2, 0),
  //     type: "video",
  //   },
  //   {
  //     title: "Rick Novak1",
  //     start: new Date(2024, 8, 24, 2, 1),
  //     end: new Date(2024, 8, 24, 2, 1),
  //     type: "video",
  //   },
  //   {
  //     title: "Rick Novak1",
  //     start: new Date(2024, 8, 24, 2, 2),
  //     end: new Date(2024, 8, 24, 2, 2),
  //     type: "video",
  //   },
  //   {
  //     title: "Rick Novak1",
  //     start: new Date(2024, 8, 24, 2, 3),
  //     end: new Date(2024, 8, 24, 2, 3),
  //     type: "video",
  //   },
  //   {
  //     title: "Rick Novak1",
  //     start: new Date(2024, 8, 24, 2, 4),
  //     end: new Date(2024, 8, 24, 2, 4),
  //     type: "video",
  //   },
  //   {
  //     title: "Rick Novak1",
  //     start: new Date(2024, 8, 24, 2, 5),
  //     end: new Date(2024, 8, 24, 2, 5),
  //     type: "video",
  //   },
  //   {
  //     title: "Roland Barr2",
  //     start: new Date(2024, 8, 24, 5, 15),
  //     end: new Date(2024, 8, 24, 5, 30),
  //     type: "cabinet",
  //   },
  //   {
  //     title: "Rick Novak3",
  //     start: new Date(2024, 8, 24, 10, 0),
  //     end: new Date(2024, 8, 24, 10, 15),
  //     type: "video",
  //   },
  //   {
  //     title: "Roland Barr4",
  //     start: new Date(2024, 8, 24, 14, 15),
  //     end: new Date(2024, 8, 24, 14, 30),
  //     type: "cabinet",
  //   },
  //   {
  //     title: "Rick Novak5",
  //     start: new Date(2024, 8, 24, 18, 0),
  //     end: new Date(2024, 8, 24, 18, 15),
  //     type: "video",
  //   },
  //   {
  //     title: "Roland Barr6",
  //     start: new Date(2024, 8, 24, 20, 15),
  //     end: new Date(2024, 8, 24, 20, 30),
  //     type: "cabinet",
  //   },
  //   {
  //     title: "Rick Novak7",
  //     start: new Date(2024, 8, 24, 8, 0),
  //     end: new Date(2024, 8, 24, 8, 15),
  //     type: "video",
  //   },
  //   {
  //     title: "Roland Barr8",
  //     start: new Date(2024, 8, 24, 8, 15),
  //     end: new Date(2024, 8, 24, 8, 30),
  //     type: "cabinet",
  //   },

  //   {
  //     title: "Rick Novak7",
  //     start: new Date(2024, 7, 7, 14, 0),
  //     end: new Date(2024, 7, 7, 14, 15),
  //     type: "video",
  //   },
  //   {
  //     title: "Roland Barr8",
  //     start: new Date(2024, 7, 7, 8, 15),
  //     end: new Date(2024, 7, 7, 8, 30),
  //     type: "cabinet",
  //   },
  //   {
  //     title: "Roland Barr8",
  //     start: new Date(2024, 7, 8, 23, 45),
  //     end: new Date(2024, 7, 8, 23, 59),
  //     type: "cabinet",
  //   },
  //   // Add more events here
  // ]);
  const [mainEvents, setMainEvents] = useState([]);
  const [events, setEvents] = useState([]);

  const [delayPopupOpen, setDelayPopupOpen] = useState(false);
  const openDelayPopup = () => setDelayPopupOpen(true);
  const closeDelayPopup = () => setDelayPopupOpen(false);

  const [selectedCheckboxes, setSelectedCheckboxes] = useState(new Set());
  const [absentEvents, setAbsentEvents] = useState(new Set()); // Track absent events
  const [isListView, setIsListView] = useState(true); // State to toggle between list and column view
  const [isIndicateBtnVisible, setIsIndicateBtnVisible] = useState(true);

  const [monthPopupOpen, setMonthPopupOpen] = useState(false);
  const [popupEvents, setPopupEvents] = useState([]);
  const [popupDate, setPopupDate] = useState(null);
  const [showFreeSlots, setShowFreeSlots] = useState(false);
  const [cancelPopupOpen, setCancelPopupOpen] = useState(false);
  const [reschedulePopupOpen, setReschedulePopupOpen] = useState(false);
  const [absensePopupOpen, setAbsensePopupOpen] = useState(false);
  const [specificDate, setSpecificDate] = useState(new Date());
  const [screenLoading, setScreenLoading] = useState(false);
  const [calenderDates, setCalenderDates] = useState({ startDate: new Date(), endDate: new Date() });
  const [selectedViewDate, setSelectedViewDate] = useState(new Date());
  const [absenceReasonList, setAbsenceReasonList] = useState();
  const [delayReasonList, setDelayReasonList] = useState();
  const [absenseReason, setAbsenseReason] = useState();
  const [modalBtnDis, setModalBtnDis] = useState(false);
  const [delayFormData, setDelayFormData] = useState({
    delayStartTime: "",
    delayDuration: "",
    delayReason: "",
  });
  const [savedDelayFormData, setSavedDelayFormData] = useState({
    delayStartTime: "",
    delayDuration: "",
    delayReason: "",
  });
  const [delayErrors, setDelayErrors] = useState({
    delayStartTime: "",
    delayDuration: "",
    delayReason: "",
  });
  const [highlightedSlots, setHighlightedSlots] = useState([]);
  const [intervalByDay, setIntervalByDay] = useState([]);
  const [slotsFromServer, setSlotsFromServer] = useState();
  const [alertedDates, setAlertedDates] = useState(new Set());
  const [needToScroll, setNeedToScroll] = useState(1);
  const [savedDelayId, setSavedDelayId] = useState();
  const [cityList, setCityList] = useState([]);
  const [cancelReason, setCancelReason] = useState("");
  const [appointmentId, setAppointmentId] = useState();
  const [cancelReasonList, setCancelReasonList] = useState([]);
  const [showCancelAppointmnet, setShowCancelAppointmnet] = useState(false);
  const [calendarValue, setCalendarValue] = useState(new Date());
  const [skelLoading, setSkelLoading] = useState(false);
  const [availDates, setAvailDates] = useState();
  const [bookedAppoinment, setBookedAppoinment] = useState();
  const [futureDate, setFutureDate] = useState();
  const [selectedTime, setSelectedTime] = useState();
  const [rescheduleReason, setRescheduleReason] = useState("");
  const [rescheduleReasonList, setRescheduleReasonList] = useState();
  const [appointmentDoctorId, setAppointmentDoctorId] = useState();
  const [appointmentConsultationType, setAppointmentConsultationType] = useState("For online consultation");

  const toggleCancelAppointmnet = () => {
    setShowCancelAppointmnet(!showCancelAppointmnet);
  };

  const handleShowFreeSlots = () => {
    setShowFreeSlots(prev => !prev);
  };

  const CustomToolbar = toolbar => {
    const goToBack = () => {
      toolbar.onNavigate("PREV");
      const currentDate = moment(toolbar.date);
      const prevDate = currentDate.subtract(1, "day");
      setSelectedViewDate(new Date(prevDate.toDate()));
      setCalenderDates({ startDate: prevDate.toDate(), endDate: prevDate.toDate() });
    };

    const goToNext = () => {
      toolbar.onNavigate("NEXT");
      const currentDate = moment(toolbar.date);
      const nextDate = currentDate.add(1, "day");
      setSelectedViewDate(new Date(nextDate.toDate()));
      setCalenderDates({ startDate: nextDate.toDate(), endDate: nextDate.toDate() });
    };

    const label = () => {
      let date = moment(toolbar.date);
      return <span className="rbc-toolbar-label">{date.format("dddd MMM D")}</span>;
    };

    return (
      <div className="rbc-toolbar">
        <button type="button" onClick={goToBack} className="prevBtn"></button>
        {label()}
        <button type="button" onClick={goToNext} className="nextBtn"></button>
      </div>
    );
  };

  const TimeHeader = () => {
    return <div className="rbc-time-header">Time</div>;
  };

  const closePopup = () => setMonthPopupOpen(false);
  const cancelOpenPopup = () => {
    setCancelPopupOpen(true);
    setMonthPopupOpen(false);
  };
  const cancelClosePopup = () => setCancelPopupOpen(false);

  const rescheduleOpenPopup = () => {
    setReschedulePopupOpen(true);
    setMonthPopupOpen(false);
  };
  const rescheduleClosePopup = () => setReschedulePopupOpen(false);

  const handleSpecificDateClick = date => {
    setSpecificDate(date);
  };

  const handleSend = () => {
    setIsIndicateBtnVisible(false);
    closeDelayPopup();
  };

  const handleEraseDelay = async () => {
    if (savedDelayId) {
      const startMoment = moment(savedDelayFormData.delayStartTime, "HH:mm");

      // Split the delay into hours and minutes
      const [delayHours, delayMinutes] = savedDelayFormData.delayDuration.split(":").map(Number);

      // Add the delay to the start time
      const endMoment = startMoment.clone().add(delayHours, "hours").add(delayMinutes, "minutes");

      // Format the new end time
      const endTime = endMoment.format("HH:mm");

      savedDelayFormData.delayEndTime = endTime;

      try {
        setScreenLoading(true);
        const fd = new FormData();
        fd.append("id", savedDelayId);
        fd.append("delay", savedDelayFormData?.delayDuration);
        fd.append("start_time", savedDelayFormData?.delayStartTime);
        fd.append("end_time", savedDelayFormData?.delayEndTime);
        fd.append("reason", savedDelayFormData?.delayReason);
        fd.append("date", moment(calenderDates.startDate).format("yyyy-MM-DD"));
        let response = await eraseDelayAppointmentApi(fd);
        if (response) {
          if (response.data.res === true) {
            // getDoctorAppointments();
            setIsIndicateBtnVisible(true);
            setDelayFormData({
              delayStartTime: "",
              delayDuration: "",
              delayReason: "",
            });
            setSavedDelayFormData({
              delayStartTime: "",
              delayDuration: "",
              delayReason: "",
            });
            toast.success(response.data.msg ? response.data.msg : "Updated successfully.", { autoClose: 1500 });
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
      } catch (error) {
        console.error(error);
        if (error.response?.status !== 403) {
          toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
        }
      } finally {
        setScreenLoading(false);
      }
    } else {
      console.error("Delay Id not found.");
      toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
    }
  };

  const generateFreeSlots = (dates, events) => {
    const slots = [];

    dates.forEach(date => {
      const startOfDay = new Date(date.setHours(0, 0, 0, 0));
      const endOfDay = new Date(date.setHours(23, 59, 59, 999));

      for (let time = new Date(startOfDay); time < endOfDay; time.setMinutes(time.getMinutes() + 15)) {
        const slotStart = new Date(time);
        const slotEnd = new Date(time);
        slotEnd.setMinutes(slotEnd.getMinutes() + 15);

        const isSlotFree = !events.some(event => (event.start <= slotStart && event.end > slotStart) || (event.start < slotEnd && event.end >= slotEnd));

        if (isSlotFree) {
          slots.push({
            title: "Free Slots",
            start: new Date(slotStart),
            end: new Date(slotEnd),
            type: "free",
          });
        }
      }

      const lastSlotStart = new Date(endOfDay);
      lastSlotStart.setMinutes(lastSlotStart.getMinutes() - 14);
      if (!events.some(event => (event.start <= lastSlotStart && event.end > lastSlotStart) || (event.start < endOfDay && event.end >= endOfDay))) {
        slots.push({
          title: "Free Slot",
          start: lastSlotStart,
          end: endOfDay,
          type: "free",
        });
      }
    });

    return slots;
  };

  useEffect(() => {
    let freeSlots = [];
    let weekDates = [];
    let monthDates = [];
    setEvents([]);

    const startOfWeek = moment(date).startOf("week").toDate();
    const endOfWeek = moment(date).endOf("week").toDate();

    const startOfMonth = moment(date).startOf("month").toDate();
    const endOfMonth = moment(date).endOf("month").toDate();

    // Generate dates for the entire week
    for (let d = new Date(startOfWeek); d <= endOfWeek; d.setDate(d.getDate() + 1)) {
      weekDates.push(new Date(d));
    }

    // Generate dates for the entire month
    for (let d = new Date(startOfMonth); d <= endOfMonth; d.setDate(d.getDate() + 1)) {
      monthDates.push(new Date(d));
    }

    if (view === "week" || view === "month") {
      // Generate free slots for week and month views
      if (view === "week") {
        freeSlots = generateFreeSlots(weekDates, mainEvents);
      } else if (view === "month") {
        freeSlots = generateFreeSlots(monthDates, mainEvents);
      }

      // Set events based on `showFreeSlots`
      if (showFreeSlots) {
        setEvents(prevEvents => prevEvents.filter(event => event.type === "free").concat(freeSlots));
      } else {
        setEvents(prevEvents => prevEvents.filter(event => event.type !== "free").concat(...mainEvents));
      }
    } else if (view === "day") {
      // For day view, display all events including free slots
      freeSlots = generateFreeSlots([date], mainEvents);
      setEvents(prevEvents =>
        prevEvents
          .filter(event => event.type !== "free")
          .concat(freeSlots)
          .concat(...mainEvents)
      );
    }

    highlightCurrentTimeSlot();
    const intervalId = setInterval(highlightCurrentTimeSlot, 200);
    return () => clearInterval(intervalId);
  }, [date, view, showFreeSlots, mainEvents]);

  useEffect(() => {
    // Show or hide buttons based on the view
    const listSwitch = document.querySelector(".listSwitch");
    const indicateBtn = document.querySelector(".indicateBtn");
    const absentBtn = document.querySelector(".absentBtn");
    const freeSlotBtn = document.querySelector(".freeSlotBtn");
    const delayDiv = document.querySelector(".delayDiv");

    // Check if elements exist before applying styles
    if (view === "week" || view === "month") {
      if (listSwitch) listSwitch.style.display = "none";
      if (indicateBtn) indicateBtn.style.display = "none";
      if (absentBtn) absentBtn.style.display = "none";
      if (delayDiv) delayDiv.style.display = "none";
      if (freeSlotBtn) freeSlotBtn.style.display = "block";
    } else if (view === "day") {
      if (listSwitch) listSwitch.style.display = "block";
      if (indicateBtn) indicateBtn.style.display = "block";
      if (absentBtn) absentBtn.style.display = "block";
      if (delayDiv) delayDiv.style.display = "block";
      if (freeSlotBtn) freeSlotBtn.style.display = "none";
    }
  }, [view]);

  const onChange = newDate => {
    setDate(newDate);
  };

  const changeView = newView => {
    if (newView === "day") {
      setCalenderDates({ startDate: new Date(selectedViewDate), endDate: new Date(selectedViewDate) });
    } else if (newView === "week") {
      let currentDate = moment(selectedViewDate);
      let newStartDate = moment(currentDate).subtract(7, "days");
      let newEndDate = moment(currentDate).add(7, "days");
      setCalenderDates({ startDate: newStartDate.toDate(), endDate: newEndDate.toDate() });
    } else if (newView === "month") {
      let currentDate = moment(selectedViewDate);
      let newStartDate = moment(currentDate).startOf("month");
      let newEndDate = moment(currentDate).endOf("month");
      setCalenderDates({ startDate: newStartDate.toDate(), endDate: newEndDate.toDate() });
    } else {
    }
    setView(newView);
  };

  const eventPropGetter = event => {
    let className;
    let tempTime = moment(event.start, "HH:mm");
    switch (event.type) {
      case "video":
        className = "videoDiv";
        break;
      case "cabinet":
        className = "cabinetDiv";
        break;
      case "free":
        className = "freeDiv";
        break;
      default:
        className = "";
    }
    if (tempTime.isSameOrAfter(moment(interval.start_time, "HH:mm")) && tempTime.isBefore(moment(interval.end_time, "HH:mm")) && view === "day") {
      className = className + " hideTimeForInterval";
    }
    if (moment(event.start).format("HH:mm") === "06:00") {
      className = className + " srollToTimeClass";
    }
    return { className };
  };

  const interval = { start_time: "2:00", end_time: "3:00", has_interval: 1 };

  useEffect(() => {
    // Initialize an array to store the new highlighted slots
    const newHighlightedSlots = [];

    // Select all rbc-timeslot-group elements
    const timeSlotGroups = document.querySelectorAll(".rbc-timeslot-group");

    timeSlotGroups.forEach(group => {
      // Extract the time from the group element (if available in its children)
      const timeLabel = group.querySelector(".rbc-label");

      if (timeLabel) {
        const time = moment(timeLabel.textContent, "h:mm A");

        // Add to highlightedSlots if time is within the interval
        if (time.isSameOrAfter(moment(interval.start_time, "HH:mm")) && time.isBefore(moment(interval.end_time, "HH:mm"))) {
          newHighlightedSlots.push(timeLabel.textContent); // Store the timeLabel text
        }
      }
    });
    // Only update state if highlighted slots have changed
    if (JSON.stringify(newHighlightedSlots) !== JSON.stringify(highlightedSlots)) {
      setHighlightedSlots(newHighlightedSlots);
    }
  }, [mainEvents, interval, highlightedSlots]);

  const handleCheckboxChange = e => {
    const title = e.id;
    setSelectedCheckboxes(prev => {
      const updated = new Set(prev);
      if (e.target.checked) {
        updated.add(title);
      } else {
        updated.delete(title);
        setAbsentEvents(prev => {
          const updatedAbsent = new Set(prev);
          updatedAbsent.delete(title);
          return updatedAbsent;
        });
      }
      return updated;
    });
  };

  const Event = ({ event }) => {
    const eventTime = moment(event.start).format("HH:mm");
    const shouldHighlight = highlightedSlots.includes(moment(event.start).format("HH:mm"));

    const handleCheckboxChange1 = e => {
      const title = event.id;
      setSelectedCheckboxes(prev => {
        const updated = new Set(prev);
        if (e.target.checked) {
          updated.add(title);
        } else {
          updated.delete(title);
          setAbsentEvents(prev => {
            const updatedAbsent = new Set(prev);
            updatedAbsent.delete(title);
            return updatedAbsent;
          });
        }
        return updated;
      });
    };

    // Check if the event is within the delay period
    const isDelayed = () => {
      if (!savedDelayFormData.delayStartTime && !savedDelayFormData.delayDuration) return false;

      const delayStart = moment(savedDelayFormData.delayStartTime, "HH:mm");
      const delayEnd = delayStart.clone().add(savedDelayFormData.delayDuration, "hours");

      return moment(event.start).isBetween(delayStart, delayEnd, null, "[)");
    };

    // if (moment(event.start).isSameOrAfter(moment(interval.start_time, "HH:mm")) && moment(event.end).isSameOrBefore(moment(interval.end_time, "HH:mm"))) {
    //   return (
    //     <div className="event-container" style={{height: 50}}>
    //       {/* Custom event rendering */}
    //       <span>{event.title}</span>
    //       <span>{eventTime}</span>
    //     </div>
    //   );
    // }

    const isInTimeRange = event => {
      const startTime = moment(event.start);
      const endTime = moment(event.end);
      // Define your time range here (example: between 08:00 and 18:00)
      const rangeStart = moment("08:00", "HH:mm");
      const rangeEnd = moment("18:00", "HH:mm");

      return startTime.isBetween(rangeStart, rangeEnd, null, "[]") || endTime.isBetween(rangeStart, rangeEnd, null, "[]");
    };

    // Only render the event if it's in the specified time range
    // if (!isInTimeRange(event)) return null;

    return (
      <div className="event-container popupMonthContain">
        <div className="popMnthLft" onClick={() => navigate(`/doctor/appointment-details/${event?.id}`)}>
          <span className="popupTime">{moment(event.start).format("HH:mm")}</span>
          <span className="popTtle">{event.title}</span>
        </div>
        {/* <div className="popMnthLft">
          <span className={`rbc-label ${shouldHighlight ? "extra-class" : ""}`}>{moment(event.start).format("HH:mm")}</span>
        </div> */}

        <span className="rgtColumn">
          {view === "day" && event.type !== "free" && (
            <>
              {absentEvents.has(event.id) && <span className="absentTxt">Absent</span>}
              {isDelayed() && <span className="absentTxt">Delay</span>}
              {!isDelayed() ? (
                (!absentEvents.has(event.id) && event.status === 1) || event.status === 0 ? (
                  <input type="checkbox" className="event-checkbox" onChange={handleCheckboxChange1} checked={selectedCheckboxes.has(event.id)} />
                ) : null
              ) : null}
            </>
          )}
        </span>
      </div>
    );
  };

  const getCalendarClass = view => {
    switch (view) {
      case "day":
        return "day-view";
      case "week":
        return "week-view";
      case "month":
        return "month-view";
      default:
        return "";
    }
  };

  const highlightCurrentTimeSlot = () => {
    const currentTime = moment();
    const timeSlotGroups = document.querySelectorAll(".rbc-timeslot-group");

    let previousSlot = null;

    timeSlotGroups.forEach(group => {
      const slots = group.querySelectorAll(".rbc-time-slot");
      slots.forEach(slot => {
        const slotTime = moment(slot.innerText, "HH:mm");

        if (currentTime.isSameOrAfter(slotTime)) {
          if (previousSlot) {
            previousSlot.classList.remove("rbc-current-time-slot");
          }
          previousSlot = slot;
        } else if (previousSlot) {
          previousSlot.classList.add("rbc-current-time-slot");
          previousSlot = null;
        }
      });
    });
  };

  const markAbsent = () => {
    if (selectedCheckboxes?.size > 0) {
      setAbsensePopupOpen(true);
    } else {
      toast.error("Something went wrong. Please try again.", { autoClose: 1500 });
    }
  };

  const markAbsentSubmit = async () => {
    if (selectedCheckboxes?.size > 0) {
      if (!absenseReason) {
        toast.warn("Please select absesnse reason.", { autoClose: 1500 });
      } else {
        setModalBtnDis(true);
        try {
          const fd = new FormData();
          Array.from(selectedCheckboxes).forEach((value, index) => {
            fd.append(`ids[${index}][id]`, value);
          });
          fd.append(`reason`, absenseReason);
          let response = await absenceAppointmentApi(fd);
          if (response) {
            if (response.data.res === true) {
              setAbsentEvents(prev => {
                const newAbsentEvents = new Set(prev);
                selectedCheckboxes.forEach(title => newAbsentEvents.add(title));
                return newAbsentEvents;
              });
              getDoctorAppointments();
              toast.success(response.data.msg ? response.data.msg : "Absence reasons updated successfully.", { autoClose: 1500 });
              setAbsensePopupOpen(false);
            } else {
              toast.error(response.data.msg, { autoClose: 1500 });
            }
          }
          setModalBtnDis(false);
        } catch (error) {
          setModalBtnDis(false);
          console.error(error);
          toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
        }
      }
    } else {
      toast.error("Something went wrong. Please try again.", { autoClose: 1500 });
    }
  };

  const handleViewToggle = () => {
    setIsListView(prev => !prev);
  };

  const CustomTimeSlotWrapper = ({ children, value }) => {
    // Format the date to HH:mm for comparison
    const time = moment(value).format("HH:mm");
    const isInTimeRange = moment(time, "HH:mm").isAfter(moment("2:00", "HH:mm")) && moment(time, "HH:mm").isBefore(moment("3:00", "HH:mm"));
    return (
      <div className={`custom-time-slot-in-interval ${isInTimeRange ? "interval-extra-class" : ""}`}>
        {time === moment(interval.start_time, "HH:mm") || time === moment(interval.end_time, "HH:mm") ? <span className="time-label">{time}</span> : null}
        {children} {/* Ensure the default children are rendered */}
      </div>
    );
  };

  const renderCalendars = () => {
    const renderMonthEvent = ({ day }) => {
      // Ensure that `events` contains the correct list of events
      const dayEvents = events.filter(e => moment(e.start).isSame(day, "day"));
      if (dayEvents.length > 0) {
        // console.log(dayEvents);
      }
      const eventElements = dayEvents.slice(0, 2).map(e => (
        <div
          key={e.title + e.start}
          className={`monthEvnt rbc-event ${eventPropGetter(e).className}`}
          onClick={() => navigate(`/doctor/appointment-details/${e.id}`)}>
          <div className="event-time">
            {moment(e.start).format("HH:mm")} - {e.title}
          </div>
        </div>
      ));

      if (dayEvents.length > 2) {
        eventElements.push(
          <div key="more" className="rbc-show-more" onClick={() => handleShowMore(day)}>
            {dayEvents.length - 2} More
          </div>
        );
      }

      return eventElements;
    };

    const handleShowMore = day => {
      const dayEvents = events.filter(event => moment(event.start).isSame(day, "day"));
      setPopupEvents(dayEvents);
      setPopupDate(day);
      setMonthPopupOpen(true);
    };

    if (view === "month") {
      return (
        <div className={`rbc-calendar ${getCalendarClass(view)}`}>
          <DnDCalendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            defaultView={view}
            view={view}
            date={date}
            onNavigate={onChange}
            style={{ height: 600 }}
            eventPropGetter={eventPropGetter}
            components={{
              event: Event,
              toolbar: CustomToolbar,
              month: {
                dateHeader: ({ label, date }) => (
                  <div className="rbc-date-header">
                    {label}
                    {renderMonthEvent({ day: date })}
                  </div>
                ),
              },
              timeGutterHeader: TimeHeader,
            }}
            step={30}
            timeslots={1}
            formats={{
              timeGutterFormat: (date, culture, localizer) => localizer.format(date, "HH:mm", culture),
              eventTimeRangeFormat: ({ start }, culture, localizer) => localizer.format(start, "HH:mm", culture),
            }}
          />
        </div>
      );
    }



    if (view === "day" && !isListView) {
      return (
        <>
          <div className={`rbc-calendar ${getCalendarClass(view)} first-half`}>
            <DnDCalendar
              localizer={localizer}
              events={events.filter(event => moment(event.start).isBefore(moment(event.start).startOf("day").add(12, "hours")))}
              startAccessor="start"
              endAccessor="end"
              defaultView={view}
              view={view}
              date={date} // Ensure the first calendar receives the correct date
              onNavigate={onChange}
              style={{ height: 600 }}
              eventPropGetter={eventPropGetter}
              components={{
                event: Event,
                toolbar: CustomToolbar,
                timeGutterHeader: TimeHeader,
                timeSlotWrapper: CustomTimeSlotWrapper,
              }}
              step={30}
              timeslots={1}
              min={new Date(date.setHours(0, 0, 0))}
              max={new Date(date.setHours(11, 59, 0))}
              formats={{
                timeGutterFormat: (date, culture, localizer) => localizer.format(date, "HH:mm", culture),
                eventTimeRangeFormat: ({ start }, culture, localizer) => localizer.format(start, "HH:mm", culture),
              }}
            />
            <StaticDayView
              isListView={isListView}
              firstHalf={1}
              mainEvents={mainEvents}
              selectedCheckboxes={selectedCheckboxes}
              handleCheckboxChange={handleCheckboxChange}
              intervalByDay={intervalByDay}
              navigate={navigate}
              slotsFromServer={slotsFromServer}
              currentDate={calenderDates.startDate}
              handleUpdateAppointments={handleUpdateAppointments}
              screenLoading={screenLoading}
              handleAppIsFinished={handleAppIsFinished}
              needToScroll={needToScroll}
              handleAddAppointment={handleAddAppointment}
              cityList={cityList}
              handleUpdatePatientFromDoctorByPatientId={handleUpdatePatientFromDoctorByPatientId}
              handleUpdateSlotBlock={handleUpdateSlotBlock}
              isPreviousDateFromCurrent={isPreviousDateFromCurrent(calenderDates.startDate) ? true : false}
              handleCancelBtnClick={handleCancelBtnClick}
              handleRescheduleBtnClick={handleRescheduleBtnClick}
            />
          </div>
          <div className={`rbc-calendar secCalendar ${getCalendarClass(view)} second-half`}>
            <DnDCalendar
              localizer={localizer}
              events={events.filter(event => moment(event.start).isSameOrAfter(moment(event.start).startOf("day").add(12, "hours")))}
              startAccessor="start"
              endAccessor="end"
              defaultView={view}
              view={view}
              date={date} // Ensure the second calendar receives the correct date
              onNavigate={onChange}
              style={{ height: 600 }}
              eventPropGetter={eventPropGetter}
              components={{
                event: Event,
                toolbar: () => null, // No toolbar for the second calendar
                timeGutterHeader: TimeHeader,
                timeSlotWrapper: CustomTimeSlotWrapper,
              }}
              step={30}
              timeslots={1}
              min={new Date(date.setHours(12, 0, 0))}
              max={new Date(date.setHours(23, 59, 0))} // Corrected to 23:59 to include the full last slot
              formats={{
                timeGutterFormat: (date, culture, localizer) => localizer.format(date, "HH:mm", culture),
                eventTimeRangeFormat: ({ start }, culture, localizer) => localizer.format(start, "HH:mm", culture),
              }}
            />
            <StaticDayView
              isListView={isListView}
              firstHalf={1}
              mainEvents={mainEvents}
              selectedCheckboxes={selectedCheckboxes}
              handleCheckboxChange={handleCheckboxChange}
              intervalByDay={intervalByDay}
              navigate={navigate}
              slotsFromServer={slotsFromServer}
              currentDate={calenderDates.startDate}
              handleUpdateAppointments={handleUpdateAppointments}
              screenLoading={screenLoading}
              handleAppIsFinished={handleAppIsFinished}
              needToScroll={needToScroll}
              handleAddAppointment={handleAddAppointment}
              cityList={cityList}
              handleUpdatePatientFromDoctorByPatientId={handleUpdatePatientFromDoctorByPatientId}
              handleUpdateSlotBlock={handleUpdateSlotBlock}
              isPreviousDateFromCurrent={isPreviousDateFromCurrent(calenderDates.startDate) ? true : false}
              handleCancelBtnClick={handleCancelBtnClick}
              handleRescheduleBtnClick={handleRescheduleBtnClick}
            />
          </div>
        </>
      );
    }

    return (
      <div className={`rbc-calendar ${getCalendarClass(view)}`}>
        <DnDCalendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          defaultView={view}
          view={view}
          date={date} // Ensure the calendar receives the correct date
          onNavigate={onChange}
          style={{ height: 600 }}
          eventPropGetter={eventPropGetter}
          components={{
            event: Event,
            toolbar: CustomToolbar,
            timeGutterHeader: TimeHeader,
            timeSlotWrapper: CustomTimeSlotWrapper,
          }}
          step={30}
          timeslots={1}
          formats={{
            timeGutterFormat: (date, culture, localizer) => localizer.format(date, "HH:mm", culture),
            eventTimeRangeFormat: ({ start }, culture, localizer) => localizer.format(start, "HH:mm", culture),
          }}
          className={`calendarMain ${showFreeSlots ? "showFreeSlot" : ""}`}
        // onEventDrop={event => console.log(event)}
        // draggableAccessor={true}

        />
        <StaticDayView
          isListView={isListView}
          firstHalf={1}
          mainEvents={mainEvents}
          selectedCheckboxes={selectedCheckboxes}
          handleCheckboxChange={handleCheckboxChange}
          intervalByDay={intervalByDay}
          navigate={navigate}
          slotsFromServer={slotsFromServer}
          currentDate={calenderDates.startDate}
          handleUpdateAppointments={handleUpdateAppointments}
          screenLoading={screenLoading}
          handleAppIsFinished={handleAppIsFinished}
          needToScroll={needToScroll}
          handleAddAppointment={handleAddAppointment}
          cityList={cityList}
          handleUpdatePatientFromDoctorByPatientId={handleUpdatePatientFromDoctorByPatientId}
          handleUpdateSlotBlock={handleUpdateSlotBlock}
          isPreviousDateFromCurrent={isPreviousDateFromCurrent(calenderDates.startDate) ? true : false}
          handleCancelBtnClick={handleCancelBtnClick}
          handleRescheduleBtnClick={handleRescheduleBtnClick}
        />
      </div>
    );
  };

  const handleUpdateSlotBlock = async (addAppObject, onSuccessCallback) => {
    try {
      setScreenLoading(true);
      const formData = new FormData();
      formData.append("patient_id", addAppObject?.patientId || "");
      formData.append("first_name", addAppObject?.patientFirstName || "");
      formData.append("last_name", addAppObject?.patientLastName || "");
      formData.append("cell_phone", addAppObject?.patientNumber || "");
      formData.append("gender", addAppObject?.patientGender || "");
      formData.append("city_id", addAppObject?.patientCity || "");
      formData.append("birth_city_id", addAppObject?.birthCity || "");
      formData.append("id_number", addAppObject?.idNumber || "");
      formData.append("year", addAppObject?.patientYear || "");
      formData.append("month", addAppObject?.patientMonth || "");
      formData.append("day", addAppObject?.patientDay || "");
      formData.append("appointment_id", addAppObject?.appointmentId || "");
      let response = await updateSlotApi(formData);
      if (response) {
        if (response.data.res === true) {
          toast.success(response.data.msg ? response.data.msg : "Updated successfully.", { autoClose: 1500 });
          if (onSuccessCallback) onSuccessCallback();
          getDoctorAppointments();
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      if (error.response?.status !== 403) {
        toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
      }
    } finally {
      setScreenLoading(false);
    }
  };

  const getDoctorAppointments = async () => {
    try {
      setScreenLoading(true);
      const fd = new FormData();
      fd.append("start_date", moment(calenderDates.startDate).format("yyyy-MM-DD"));
      fd.append("end_date", moment(calenderDates.endDate).format("yyyy-MM-DD"));
      let response = await doctorFetchAppointmentsApi(fd);
      if (response) {
        if (response.data.res === true) {
          setSlotsFromServer(response.data.slots);
          let tempArray = [];
          let tempAbsentEvents = new Set();
          if (response.data.data.length > 0) {
            response.data.data.map(item => {
              if (item.status === 3) {
                tempAbsentEvents.add(item.id);
              }
              // setAbsentEvents(prev => {
              //   const newAbsentEvents = new Set(prev);
              //   selectedCheckboxes.forEach(title => newAbsentEvents.add(title));
              //   return newAbsentEvents;
              // });

              // Appointment dates are civil dates, not UTC instants. Build them in the
              // browser's local timezone so a day-n appointment stays on day n in every view.
              const start = parseAppointmentDate(item.appointment_date, item.time);
              const end = start.clone().add(15, "minutes");

              tempArray.push({
                id: item.id,
                patient_id: item.patient_id,
                doctor_id: item.doctor_id,
                consultation_type: item.consultation_type,
                status: item.status,
                title: item.name,
                time: item.time,
                questions: item.questions,
                confirm: item.confirm,
                start: start.toDate(),
                end: end.toDate(),
                type: item?.consultation_type === "For online consultation" ? "video" : item?.consultation_type === "For cabinet consultation" ? "cabinet" : "",
                orders: item?.orders,
                priority: item?.userpriority,
                supports: item?.usersupport,
                finish: item?.finish,
                refer_name: item?.refer_name,
                patient_details: item?.patient_details,
              });
            });
          }
          // tempArray.push({
          //   title: "Roland Barr2",
          //   start: new Date(2024, 8, 18, 0, 15),
          //   end: new Date(2024, 8, 18, 0, 30),
          //   type: "cabinet",
          // });
          // console.log(tempArray);
          setMainEvents(tempArray || []);
          let tempIntArray = [];
          response.data.interval.forEach(element => {
            tempIntArray.push({ startTime: element.start_time, endTime: element.end_time, has_interval: element.has_interval, visitor: element.visitor });
          });
          setIntervalByDay(tempIntArray || []);
          setAbsentEvents(tempAbsentEvents);

          if (!alertedDates.has(calenderDates.startDate)) {
            setAlertedDates(prev => new Set(prev).add(calenderDates.startDate));
            setNeedToScroll(prev => prev + 1);
          }

          if (response.data.DoctorDelays.length > 0 && response.data.DoctorDelays[0].start_time) {
            setSavedDelayFormData({
              delayStartTime: response.data.DoctorDelays[0]?.start_time,
              delayDuration: response.data.DoctorDelays[0]?.delay,
              delayReason: response.data.DoctorDelays[0]?.reason,
            });
            setIsIndicateBtnVisible(false);
            setSavedDelayId(response.data.DoctorDelays[0].id);
          } else {
            setIsIndicateBtnVisible(true);
          }
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
      setScreenLoading(false);
    } catch (error) {
      setScreenLoading(false);
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
    }
  };

  // Real-time: refresh the calendar when the doctor (or another nurse) finishes /
  // cancels / reschedules / re-prioritises an appointment, without reloading.
  useBroadcastListener({
    channelName: nurseUserId
      ? APPOINTMENT_BROADCAST_KEYS.channels.appointments(nurseUserId)
      : null,
    isPrivate: true,
    enabled: !!nurseUserId,
    events: {
      [APPOINTMENT_BROADCAST_KEYS.events.APPOINTMENT_FINISHED]: () => getDoctorAppointments(),
      [APPOINTMENT_BROADCAST_KEYS.events.APPOINTMENT_PRIORITY_CHANGED]: () => getDoctorAppointments(),
      [APPOINTMENT_BROADCAST_KEYS.events.APPOINTMENT_UPDATED]: () => getDoctorAppointments(),
      [APPOINTMENT_BROADCAST_KEYS.events.APPOINTMENT_CANCELED]: () => getDoctorAppointments(),
      [APPOINTMENT_BROADCAST_KEYS.events.APPOINTMENT_RESCHEDULED]: () => getDoctorAppointments(),
      [APPOINTMENT_BROADCAST_KEYS.events.APPOINTMENT_CREATED]: () => getDoctorAppointments(),
    },
  });

  const handleUpdateAppointments = async (fromId, toId) => {
    try {
      setScreenLoading(true);
      const fd = new FormData();
      fd.append("from_id", fromId);
      fd.append("to_id", toId);
      let response = await updateAppointmentsOrderApi(fd);
      if (response) {
        if (response.data.res === true) {
          getDoctorAppointments();
          toast.success(response.data.msg, { autoClose: 1500 });
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
    } finally {
      setScreenLoading(true);
    }

    sessionStorage.removeItem("doctolikAppointmentDragObject");
  };

  const getAbsenceReason = async () => {
    try {
      let response = await getAbsenceReasonApi();
      if (response) {
        if (response.data.res === true) {
          setAbsenceReasonList(response.data.data);
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
    }
  };

  const getDelayReason = async () => {
    try {
      let response = await getDelayReasonApi();
      if (response) {
        if (response.data.res === true) {
          setDelayReasonList(response.data.data);
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
    }
  };

  const { 
    data: cities,
    refetch: refetchCities,
    isError: isCitiesError,
    isLoading: isCitiesLoading,
    error: citiesError,
  } = useCities()

  const getCityList = async () => {
    try {
      if (cities) {
        setCityList(cities);
      } else if(citiesError) {
        throw new Error("Error fetching cities because response is : ", citiesError);
      }
    } catch (error) {
      toast.error(error.message, { autoClose: 1500 });
    }
  };

  const handleDelayChange = e => {
    const { name, value } = e.target;
    setDelayFormData({
      ...delayFormData,
      [name]: value,
    });
    setDelayErrors({
      ...delayErrors,
      [name]: "",
    });
  };

  const validateDelayFields = () => {
    const errors = {};
    let isValid = true;

    // Validate delay starting time
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    if (!timeRegex.test(delayFormData.delayStartTime)) {
      errors.delayStartTime = "Please enter a valid start time (HH:MM).";
      isValid = false;
    }

    if (!timeRegex.test(delayFormData.delayDuration)) {
      errors.delayDuration = "Please enter a valid duration time (HH:MM).";
      isValid = false;
    }

    // Validate delay duration
    // const durationNum = parseInt(delayFormData.delayDuration, 10);
    // if (!Number.isInteger(durationNum) || durationNum <= 0) {
    //   errors.delayDuration = "Please enter a positive integer for the duration.";
    // } else if (durationNum > 24) {
    //   errors.delayDuration = "Duration should not exceed 24 hours.";
    // }

    // Validate delay reason
    if (!delayFormData.delayReason) {
      errors.delayReason = "Please select a reason.";
      isValid = false;
    }
    setDelayErrors(errors);
    return isValid;
  };

  const handleAddDelay = async () => {
    if (validateDelayFields()) {
      // Parse the delayStartTime
      const startMoment = moment(delayFormData.delayStartTime, "HH:mm");

      // Split the delay into hours and minutes
      const [delayHours, delayMinutes] = delayFormData.delayDuration.split(":").map(Number);

      // Add the delay to the start time
      const endMoment = startMoment.clone().add(delayHours, "hours").add(delayMinutes, "minutes");

      // Format the new end time
      const endTime = endMoment.format("HH:mm");

      delayFormData.delayEndTime = endTime;

      try {
        setScreenLoading(true);
        const fd = new FormData();
        fd.append("delay", delayFormData?.delayDuration);
        fd.append("start_time", delayFormData?.delayStartTime);
        fd.append("end_time", delayFormData?.delayEndTime);
        fd.append("reason", delayFormData?.delayReason);
        fd.append("date", moment(calenderDates.startDate).format("yyyy-MM-DD"));
        let response = await delayAppointmentApi(fd);
        if (response) {
          if (response.data.res === true) {
            setDelayPopupOpen(false);
            setIsIndicateBtnVisible(false);
            setSavedDelayFormData(delayFormData);
            setSavedDelayId(response.data.delay_id);
            toast.success(response.data.msg ? response.data.msg : "Updated successfully.", { autoClose: 1500 });
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
      } catch (error) {
        console.error(error);
        if (error.response?.status !== 403) {
          toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
        }
      } finally {
        setScreenLoading(false);
      }
    }
  };

  const handleAppIsFinished = async (appId, value) => {
    try {
      setScreenLoading(true);
      const fd = new FormData();
      fd.append("id", appId);
      fd.append("type", "finish");
      fd.append("value", value);
      let response = await updatePriorityApi(fd);
      if (response) {
        if (response.data.res === true) {
          getDoctorAppointments();
          toast.success(response.data.msg ? response.data.msg : "Updated successfully.", { autoClose: 1500 });
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
    } finally {
      setScreenLoading(true);
    }
  };

  const handleAddAppointment = addAppObject => {
    sessionStorage.setItem("doctolikAddAppObjByNurse", JSON.stringify(addAppObject));
    navigate(`/nurse/appointment-booking`);
  };

  const handleUpdatePatientFromDoctorByPatientId = async (addAppObject, onSuccessCallback) => {
    try {
      setScreenLoading(true);
      const formData = new FormData();
      formData.append("patient_id", addAppObject?.patientId || "");
      formData.append("first_name", addAppObject?.patientFirstName || "");
      formData.append("last_name", addAppObject?.patientLastName || "");
      formData.append("cell_phone", addAppObject?.patientNumber || "");
      formData.append("gender", addAppObject?.patientGender || "");
      formData.append("city_id", addAppObject?.patientCity || "");
      formData.append("birth_city_id", addAppObject?.birthCity || "");
      formData.append("id_number", addAppObject?.idNumber || "");
      formData.append("year", addAppObject?.patientYear || "");
      formData.append("month", addAppObject?.patientMonth || "");
      formData.append("day", addAppObject?.patientDay || "");
      formData.append("appointment_id", addAppObject?.appointmentId || "");
      let response = await updatePatientFromDoctorByPatientIdApi(formData);
      if (response) {
        if (response.data.res === true) {
          toast.success(response.data.msg ? response.data.msg : "Updated successfully.", { autoClose: 1500 });
          if (onSuccessCallback) onSuccessCallback();
          getDoctorAppointments();
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
    } finally {
      setScreenLoading(false);
    }
  };

  const handleCancelBtnClick = appId => {
    setAppointmentId(appId);
    setShowCancelAppointmnet(true);
  };

  const handleRescheduleBtnClick = (appId, doctorId, consultationType) => {
    setAppointmentId(appId);
    setAppointmentDoctorId(doctorId);
    setAppointmentConsultationType(consultationType || "For online consultation");
    setReschedulePopupOpen(true);
    getDateAvailabilityList(doctorId, format(date, "yyyy-MM-dd"), consultationType || "For online consultation");
  };

  const handleDateClick = async date => {
    const newDate = date.toDateString();
    setCalendarValue(date);
    getDateAvailabilityList(appointmentDoctorId, format(date, "yyyy-MM-dd"), appointmentConsultationType);
  };

  const getDateAvailabilityList = async (docId, date, consultationType) => {
    if (docId && date && consultationType) {
      try {
        setSkelLoading(true);
        let formData = new FormData();
        formData.append("doctor_id", docId);
        formData.append("date", date);
        formData.append("consultation_types", consultationType);

        let response = await dateAvailabilityApi(formData);
        if (response) {
          if (response.data.res === true) {
            const tempFormatHoliday = response.data.holiday ? response.data.holiday.map(item => item.holiday_date) : [];
            if (tempFormatHoliday.includes(date)) {
              setAvailDates([]);
            } else {
              setAvailDates(response.data.data);
            }
            setBookedAppoinment(response.data.notAvailable.map(({ time }) => time));
            const tempFutureDate = moment().add(parseInt(response.data.future_days, 10), "days");
            setFutureDate(tempFutureDate);
            setSelectedTime(null);
            setRescheduleReason(null);
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setSkelLoading(false);
      } catch (error) {
        setSkelLoading(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
      }
    }
  };

  const tileClassName = ({ date }) => {
    const formattedDate = date.toDateString();
    return calendarValue === formattedDate ? "highlighted-date" : null;
  };

  const handleActiveStartDateChange = ({ action, activeStartDate, view }) => {
    if (action === "prev" || action === "next") {
      const formattedDate = format(activeStartDate, "yyyy-MM");
      getDateAvailabilityList(appointmentDoctorId, `${formattedDate}-01`, appointmentConsultationType);
    }
  };

  const handleSelectTime = time => {
    if (time.has_interval === 1) {
      let title = time?.start_time + "-" + time?.end_time;
      let count = 0;
      bookedAppoinment.forEach(element => {
        if (element === title) {
          count += 1;
        }
      });

      if (count >= time?.visitor) {
        toast.warning("Oops! This time slot is full. Please try on different time.", { autoClose: 1500 });
        setSelectedTime(null);
      } else {
        setSelectedTime(title);
      }
    } else {
      if (bookedAppoinment.includes(time)) {
        toast.warning("Oops! This time slot is already taken. Please choose a different slot.", { autoClose: 1500 });
        setSelectedTime(null);
      } else {
        setSelectedTime(time);
      }
    }
  };

  const generateTimeSlots = (startTime, endTime, interval, timeSlotType) => {
    const slots = [];

    // Create moment objects for the start and end times
    const startMoment = moment(startTime, "HH:mm");
    const endMoment = moment(endTime, "HH:mm");

    // Loop to generate time slots
    while (startMoment.isBefore(endMoment)) {
      slots.push(startMoment.format("HH:mm")); // Format as HH:mm
      if (timeSlotType === "Minute") {
        startMoment.add(interval, "minutes"); // Increment by the interval in minutes
      } else if (timeSlotType === "Hour") {
        startMoment.add(interval, "hours"); // Increment by the interval in hours
      }
    }

    // Remove the last slot if it equals the end time
    if (slots[slots.length - 1] === endMoment.format("HH:mm")) {
      slots.pop();
    }
    return slots;
  };

  const handleReschedule = async () => {
    if (!selectedTime) {
      toast.warning("Please select a time.", { autoClose: 1500 });
    } else if (!rescheduleReason) {
      toast.warning("Please select reschedule reason.", { autoClose: 1500 });
    } else {
      try {
        setModalBtnDis(true);
        const fd = new FormData();
        fd.append("id", appointmentId);
        fd.append("reason", rescheduleReason);
        fd.append("appointment_date", format(calendarValue, "yyyy-MM-dd"));
        fd.append("time", selectedTime);

        let response = await rescheduleAppointmentApi(fd);
        if (response) {
          if (response.data.res === true) {
            toast.success(response.data.msg ? response.data.msg : "Appointment rescheduled successfully.", { autoClose: 1500 });
            getDateAvailabilityList(appointmentDoctorId, format(calendarValue, "yyyy-MM-dd"), appointmentConsultationType);
            setReschedulePopupOpen(false);
            getDoctorAppointments();
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setModalBtnDis(false);
      } catch (error) {
        setModalBtnDis(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
      }
    }
  };

  const getRescheduleReason = async () => {
    try {
      let response = await getRescheduleReasonApi();
      if (response) {
        if (response.data.res === true) {
          setRescheduleReasonList(response.data.data);
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
    }
  };

  const getCancelReason = async () => {
    try {
      let response = await getCancelReasonApi();
      if (response) {
        if (response.data.res === true) {
          setCancelReasonList(response.data.data);
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
    }
  };

  const handleCancelAppointment = async () => {
    if (!cancelReason) {
      toast.warning("Please select cancel reason.", { autoClose: 1500 });
    } else if (!appointmentId) {
      toast.warning("Appointment not found.", { autoClose: 1500 });
    } else {
      try {
        setModalBtnDis(true);
        const fd = new FormData();
        fd.append("id", appointmentId);
        fd.append("reason", cancelReason);

        let response = await cancelAppointmentApi(fd);
        if (response) {
          if (response.data.res === true) {
            toast.success(response.data.msg ? response.data.msg : "Appointment cancelled successfully.", { autoClose: 1500 });
            setShowCancelAppointmnet(false);
            setAppointmentId(null);
            getDoctorAppointments();
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
      } catch (error) {
        console.error(error);
        if (error.response?.status !== 403) {
          toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
        }
      } finally {
        setModalBtnDis(false);
      }
    }
  };

  useEffect(() => {
    getDoctorAppointments();
  }, [calenderDates]);

  useEffect(() => {
    getAbsenceReason();
    getDelayReason();
    getCityList();
    getCancelReason();
    getRescheduleReason();
  }, []);
  useEffect(() => {
    const scrollToElement = document.querySelector(".srollToTimeClass");
    if (scrollToElement && view !== "month") {
      scrollToElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [events, view]);
  return (
    <div className="doctormain">
      <Sidebar />
      <div className="rightSec">
        <DashboardDoctorHeader />
        {screenLoading && <LoadingPage />}
        <div className="mainDiv">
          <div className="hdnDiv nurseTop nurseTop2 nurseTop4">
            <h2>
              <span>
                <img src={icon1} alt="Availability icon" />
                All appointments <strong>Showing {moment(date).format("dddd, MMMM Do YYYY")}</strong>
              </span>
              <span>
                <p className="videoConsult">Video Consultation</p>
                <p className="cabinetConsult">Cabinet consultation</p>
                {view === "day" ? (
                  <div className="listSwitch">
                    {isListView ? "List View" : "Column View"}
                    <input type="checkbox" id="switch" checked={!isListView} onChange={handleViewToggle} />
                    <label htmlFor="switch">Toggle</label>
                  </div>
                ) : null}
              </span>
            </h2>
          </div>
          {/* {!screenLoading ? ( */}
          <div className="appointmentFoot">
            <div className="mainClndBtns">
              <div className="clndBtns">
                <div className="filters">
                  <button onClick={() => changeView("day")} className={view === "day" ? "active" : ""}>
                    Day
                  </button>
                  <button onClick={() => changeView("week")} className={view === "week" ? "active" : ""}>
                    Week
                  </button>
                  <button onClick={() => changeView("month")} className={view === "month" ? "active" : ""}>
                    Month
                  </button>
                </div>
                <button
                  className="absentBtn"
                  onClick={() => markAbsent()}
                  disabled={selectedCheckboxes.size === 0 || isPreviousDateFromCurrent(calenderDates.startDate) ? true : false}>
                  Mark as absent
                </button>
              </div>
              <div className="listViewDiv">
                {view !== "day" ? (
                  <button onClick={handleShowFreeSlots} className="freeSlotBtn">
                    {showFreeSlots ? "Hide free slots" : "Show free slots"}
                  </button>
                ) : null}
                {view === "day" ? (
                  isIndicateBtnVisible ? (
                    <button className="indicateBtn" onClick={openDelayPopup} disabled={isPreviousDateFromCurrent(calenderDates.startDate)}>
                      Indicate delay
                    </button>
                  ) : (
                    <div className="delayDiv">
                      Delay Starting at:
                      <input type="text" readOnly placeholder={savedDelayFormData.delayStartTime} className="delayInput" />
                      Duration:
                      <input type="text" readOnly placeholder={savedDelayFormData.delayDuration + " hrs"} className="durationInput" />
                      <button className="eraseBtn" onClick={handleEraseDelay}>
                        Erase delay
                      </button>
                    </div>
                  )
                ) : null}
              </div>
            </div>

            <div className="calendarMain">{renderCalendars()}</div>
          </div>
          {/* ) : null} */}
        </div>
      </div>

      {absensePopupOpen && (
        <div className="popup holidayPopup">
          <div className="popup-content">
            <button onClick={() => setAbsensePopupOpen(false)} className="cancelBtn">
              <img src={cancelIcon} alt="" />
            </button>
            <div className="addNursePopup">
              <h2 className="nurseHdn">Mark as Absense</h2>
              <ul>
                <li>
                  <label>What is reason of absense?</label>
                  <select value={absenseReason} onChange={e => setAbsenseReason(e.target.value)}>
                    <option selected hidden>
                      Select reason here
                    </option>
                    {absenceReasonList?.map((item, index) => (
                      <option key={index} value={item?.name}>
                        {item?.name}
                      </option>
                    ))}
                  </select>
                </li>
                <li>
                  <button onClick={() => markAbsentSubmit()} disabled={modalBtnDis}>
                    {modalBtnDis ? "Please wait..." : "Submit"}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {delayPopupOpen && (
        <div className="popup holidayPopup">
          <div className="popup-content">
            <button onClick={closeDelayPopup} className="cancelBtn">
              <img src={cancelIcon} alt="" />
            </button>
            <div className="addNursePopup">
              <h2 className="nurseHdn">Delay Time</h2>
              <ul>
                <li>
                  <label>Delay starting time (HH:MM):</label>
                  <input
                    className={`${delayErrors.delayStartTime ? "inputHaveError" : ""}`}
                    type="text"
                    name="delayStartTime"
                    placeholder="Please enter your delay hour (HH:MM)"
                    value={delayFormData.delayStartTime}
                    onChange={handleDelayChange}
                  />
                  {delayErrors.delayStartTime && <p className="validationErrorMsg">{delayErrors.delayStartTime}</p>}
                </li>
                <li>
                  <label>Delay duration time (HH:MM):</label>
                  <input
                    className={`${delayErrors.delayDuration ? "inputHaveError" : ""}`}
                    type="text"
                    name="delayDuration"
                    placeholder="Please enter your time (HH:MM)"
                    value={delayFormData.delayDuration}
                    onChange={handleDelayChange}
                  />
                  {delayErrors.delayDuration && <p className="validationErrorMsg">{delayErrors.delayDuration}</p>}
                </li>
                <li>
                  <label>What is the reason for the delay?</label>
                  <select
                    className={`${delayErrors.delayReason ? "inputHaveError" : ""}`}
                    name="delayReason"
                    value={delayFormData.delayReason}
                    onChange={handleDelayChange}>
                    <option value={null} selected hidden>
                      Select reason here
                    </option>
                    {delayReasonList?.map((item, index) => (
                      <option key={index} value={item?.name}>
                        {item?.name}
                      </option>
                    ))}
                  </select>
                  {delayErrors.delayReason && <p className="validationErrorMsg">{delayErrors.delayReason}</p>}
                </li>
                <li>
                  <button onClick={() => handleAddDelay()}>Send</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {monthPopupOpen && (
        <div className="popup holidayPopup">
          <div className="popup-content popupMonth">
            <button onClick={closePopup} className="cancelBtn">
              <img src={cancelIcon} alt="" />
            </button>
            <h3>{moment(popupDate).format("MMMM Do YYYY")}</h3>
            <ul className="">
              {popupEvents.map(event => (
                <li className={event.type} key={event.title}>
                  <div className="eventDetails">
                    <Event event={event} />
                  </div>
                  <div className="dotPop" onClick={e => e.currentTarget.classList.toggle("active")}>
                    <img src={dotlIcon} alt="" />
                    <div className="dotInner">
                      <p onClick={rescheduleOpenPopup}>Reschedule</p>
                      <p onClick={cancelOpenPopup}>Cancel</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {cancelPopupOpen && (
        <div className="popup holidayPopup">
          <div className="popup-content popupMonth">
            <button onClick={cancelClosePopup} className="cancelBtn">
              <img src={cancelIcon} alt="" />
            </button>
            <h3>Cancel appointment</h3>
            <h4 className="cancelTxt">Are you sure you want to cancel this appointment?</h4>

            <div className="cancelForm">
              <h4>What is reason of appointment cancellation?</h4>
              <select>
                <option>Select reason here</option>
              </select>
              <button>Yes Cancel Appointment</button>
            </div>
          </div>
        </div>
      )}

      {reschedulePopupOpen && (
        <div className="popup holidayPopup ReschedulePopup">
          <div className="popup-content">
            <button
              onClick={() => {
                setReschedulePopupOpen(false);
                setCalendarValue(new Date());
              }}
              className="cancelBtn">
              <img src={cancelIcon} alt="cancelIcon" />
            </button>
            <div className="popupInner">
              <div className="calendar-section">
                <h3>Reschedule</h3>
                <h5>Make date specific changes</h5>
                <div className="overlayBtn"></div>
                <Calendar2
                  onChange={handleDateClick}
                  value={calendarValue}
                  tileClassName={tileClassName}
                  onActiveStartDateChange={handleActiveStartDateChange}
                  minDate={new Date()}
                />
              </div>
              <div className="selected-dates">
                <div className="TopHead">
                  <h3>
                    {format(calendarValue, "EEEE")} <span>{format(calendarValue, "MMMM d, yyyy")}</span>
                  </h3>
                  <p>Available Time Slot</p>
                </div>
                {skelLoading ? (
                  <div className="SkelWrapper">
                    <Skeleton count={2} height={20} width={"80%"} baseColor="#cfd5f9" />
                  </div>
                ) : (
                  <ul>
                    {availDates?.length > 0 && !moment(calendarValue).isSameOrAfter(futureDate) ? (
                      availDates?.map((item, index) => {
                        const currentTime = moment().add(1, "hour");
                        const isToday = moment(calendarValue).isSame(currentTime, "day");
                        return (
                          // <li key={index} className={selectedTime === item ? "active" : ""} onClick={() => setSelectedTime(item)}>
                          item?.has_interval === 1 ? (
                            isToday ? (
                              moment(item?.start_time, "HH:mm").isSameOrAfter(currentTime) ? (
                                <li
                                  key={index}
                                  className={selectedTime === item?.start_time + "-" + item?.end_time ? "active" : ""}
                                  onClick={() => handleSelectTime(item)}>
                                  <span>
                                    {item?.start_time} to {item?.end_time}
                                  </span>
                                </li>
                              ) : null
                            ) : (
                              <li
                                key={index}
                                className={selectedTime === item?.start_time + "-" + item?.end_time ? "active" : ""}
                                onClick={() => handleSelectTime(item)}>
                                <span>
                                  {item?.start_time} to {item?.end_time}
                                </span>
                              </li>
                            )
                          ) : (
                            generateTimeSlots(item?.start_time, item?.end_time, item?.intervals, item?.time_slot_type).map((timeItem, timeIndex) => {
                              if (isToday) {
                                if (moment(timeItem, "HH:mm").isSameOrAfter(currentTime)) {
                                  return (
                                    <li key={timeIndex} className={selectedTime === timeItem ? "active" : ""} onClick={() => handleSelectTime(timeItem)}>
                                      <span
                                        style={{ backgroundColor: bookedAppoinment?.includes(timeItem) ? "#616161" : "" }}
                                      >{timeItem}</span>
                                    </li>
                                  );
                                } else {
                                  return null;
                                }
                              } else {
                                return (
                                  <li key={timeIndex} className={selectedTime === timeItem ? "active" : ""}
                                    onClick={() => !bookedAppoinment?.includes(timeItem) && handleSelectTime(timeItem)}
                                  //onClick={() => handleSelectTime(timeItem)}
                                  >
                                    <span
                                      style={{
                                        backgroundColor: bookedAppoinment?.includes(timeItem) ? "#616161" : "",
                                        cursor: bookedAppoinment?.includes(timeItem) ? "not-allowed" : ""
                                      }}
                                    >{timeItem}</span>
                                  </li>
                                );
                              }
                            })
                          )
                        );
                      })
                    ) : (
                      <p>No times available for this day.</p>
                    )}
                  </ul>
                )}
                <div className="BottomSecion">
                  <label>What is reason of appointment reschedule?</label>
                  <div className="CustomSelect">
                    <select value={rescheduleReason} onChange={e => setRescheduleReason(e.target.value)}>
                      <option hidden value="">
                        Select reason here
                      </option>
                      {rescheduleReasonList?.map((item, index) => (
                        <option key={index} value={item?.name}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <button className="saveBtn2" onClick={() => handleReschedule()} disabled={modalBtnDis}>
                  {modalBtnDis ? "Please wait..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showCancelAppointmnet && (
        <div className="modal CancelAppointmnetModal" onClick={toggleCancelAppointmnet}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <button className="CloseButton" onClick={toggleCancelAppointmnet}></button>
              <h3>Cancel appointment</h3>
              <p>Are you sure you want to cancel this appointment?</p>
            </div>
            <div className="modal-body">
              <ul className="AddIndicatorList">
                <li>
                  <label>What is reason of appointment cancellation?</label>
                  <div className="CustomSelect">
                    <select value={cancelReason} onChange={e => setCancelReason(e.target.value)}>
                      <option hidden value="">
                        Select reason here
                      </option>
                      {cancelReasonList?.map((item, index) => (
                        <option key={index} value={item?.name}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </li>
              </ul>
            </div>
            <ul className="ButtonList">
              <li>
                <button className="ModalCloseBtn" disabled={modalBtnDis} onClick={() => handleCancelAppointment()}>
                  {modalBtnDis ? "Please wait..." : "Yes Cancel Appointment"}
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default NurseAppointments;
